import { OverlayTrigger, OverlayTriggerProps, Popover } from 'react-bootstrap';
import React, { ReactElement, ReactNode } from 'react';

export type PropsDePopover = Partial<OverlayTriggerProps> & {
    id?: string;
    texte: ReactNode;
    titre?: ReactNode;
    children: ReactElement;
    inList?: boolean;
    backgroundColor?: string;
};

export default function PopoverSimple({
    id,
    texte,
    titre,
    children,
    inList,
    backgroundColor = '#fff',
    ...rest
}: PropsDePopover): ReactElement {
    return (
        <OverlayTrigger
            {...rest}
            overlay={
                <Popover
                    id={id as string}
                    style={{ width: 'auto!important', maxWidth: 'none', backgroundColor: backgroundColor }}
                >
                    {titre ? <Popover.Title as="h3">{titre}</Popover.Title> : null}
                    <Popover.Content>{texte}</Popover.Content>
                </Popover>
            }
        >
            {inList ? <div className="d-inline">{children}</div> : children}
        </OverlayTrigger>
    );
}

PopoverSimple.defaultProps = {
    id: 'popover-generique',
};
